module.exports = __webpack_public_path__ + "img/input-cursor-text.3fc269b6.svg";